export default {
  namespaced: true,
  state: {
    i18n: {},
  },
  getters: {
    translations: state => state.i18n.translations,
    translationsScoped: state => scope => {
      const scopes = scope.split(".");
      let current = state.i18n.translations;
      scopes.forEach(scope => {
        const newCurrent = current[scope];
        if (newCurrent != undefined) {
          current = newCurrent;
        } else {
          throw "Missing Translation Scope";
        }
      });
      return current;
    },
    currentLocale: state => state.i18n.currentLocale,
    availableLocales: state => state.i18n.availableLocales,
  },
  actions: {
    setI18n: ({ commit }, i18n) => commit("setI18n", i18n),
  },
  mutations: {
    setI18n: (state, i18n) => (state.i18n = i18n),
  },
};
